import axios from 'axios';

import {
  API_ROOT,
  CLIENT_HEADERS,
  devEnv,
  isMockprod,
  isStaging,
} from '#src/config.ts';

import { toCamelCase } from './toCamelCase.ts';

const xsrfHeaderName = 'X-CSRF-Token';
export const xsrfCookieName = devEnv ? `csrftoken_${devEnv}` : 'csrftoken';
export const xsrfReceivingHeaderName = 'csrf-token';
const cloudflareAccessHeaders =
  import.meta.env.VITE_CLOUDFLARE_ACCESS_CLIENT_ID && (isStaging || isMockprod)
    ? {
        'CF-Access-Client-Id': import.meta.env.VITE_CLOUDFLARE_ACCESS_CLIENT_ID,
        'CF-Access-Client-Secret': import.meta.env
          .VITE_CLOUDFLARE_ACCESS_CLIENT_SECRET,
      }
    : {};

export const onError = (error: any) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    return error.response.data;
  }

  // Something happened in setting up the request that triggered an Error
  return { error: error.message };
};

const instance = ({ withCredentials = true } = {}) =>
  axios.create({
    baseURL: API_ROOT,
    xsrfCookieName,
    xsrfHeaderName,
    withCredentials,
    headers: {
      ...cloudflareAccessHeaders,
      ...CLIENT_HEADERS,
    },
  });

export const client = instance({ withCredentials: true });
export const clientWithoutCredentials = instance({ withCredentials: false });

export const formatUpdateUserErrors = (errors: any) =>
  Object.entries<any>(errors).reduce<Record<string, string>>((sum, cur) => {
    const [key, [err]] = cur;
    sum[toCamelCase(key)] = err;
    return sum;
  }, {});

export async function load<T extends NonNullable<unknown>>(
  url: string,
  withCredentials = false
): Promise<T> {
  const c = withCredentials ? client : axios;

  const { data } = await c.get(url);
  return data;
}
